import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-292eacf7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reports-table" }
const _hoisted_2 = { class: "reports-table__pagination" }

import { defineComponent, onMounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {
  IndexType,
  ResponseReportType,
  TableReportType,
} from '@/widgets/WReportsTable/types/report.type'
import { reportsApi } from '@/shared/api'
import { showErrorMessage } from '@/shared/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()

const pagination = reactive({
  currentPage: 1,
  totalPages: 0,
})

const paginationInfo = reactive({
  showingFrom: 0,
  showingTo: 0,
  total: 0,
})

const reportsData = ref<Omit<TableReportType, 'index'>[]>()
const loading = ref(false)

const getReportsData = async (): Promise<void> => {
  loading.value = true

  const [error, response] = await reportsApi.getAdminReports(
    pagination.currentPage
  )

  if (error) {
    showErrorMessage(error)
  } else {
    reportsData.value = []

    pagination.totalPages = Math.ceil(response.reports.total / 10)
    paginationInfo.showingFrom = response.reports.from
    paginationInfo.showingTo = response.reports.to
    paginationInfo.total = response.reports.total

    setReportList(response.reports.reports)
  }

  loading.value = false
}

const setReportList = (reports: ResponseReportType[]) => {
  for (const report of reports) {
    const index: IndexType | null = JSON.parse(report.index)

    const result = index
      ? `${Math.round((index.day + index.week + index.month) * 100)}%`
      : '0%'

    let status = null
    if (report.is_processed === false) {
      status = 'Не обработано'
    } else if (index === null) {
      status = 'Ошибка обработки'
    } else if (index.fedorov_volodkina === 0) {
      status = 'Ошибка значений'
    } else {
      status = 'Успешно'
    }

    const newReport: Omit<TableReportType, 'index'> = {
      id: report.id,
      email: report.email,
      organization_name: report.organization_name,
      status: status,
      result,
      date_at: report.date_at,
      ai_time: report.ai_time,
    }

    reportsData.value.push(newReport)
  }
}

const handleChangeCurrentPage = (page: number): void => {
  pagination.currentPage = page
  router.push({ query: { page: pagination.currentPage } })

  getReportsData()
}

onMounted((): void => {
  pagination.currentPage = Number(route.query.page)

  getReportsData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: reportsData.value,
      class: "reports-table__inner"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "id",
          prop: "id"
        }),
        _createVNode(_component_el_table_column, {
          label: "Email",
          prop: "email"
        }),
        _createVNode(_component_el_table_column, {
          label: "Клиника",
          prop: "organization_name"
        }),
        _createVNode(_component_el_table_column, {
          label: "Статус",
          prop: "status"
        }),
        _createVNode(_component_el_table_column, {
          label: "Результат",
          prop: "result"
        }),
        _createVNode(_component_el_table_column, {
          label: "Дата",
          prop: "date_at"
        }),
        _createVNode(_component_el_table_column, {
          label: "AI-Time(sec)",
          prop: "ai_time"
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_pagination, {
        "current-page": _unref(pagination).currentPage,
        "page-size": 1,
        total: _unref(pagination).totalPages,
        background: "",
        class: "reports-table__pagination-item",
        layout: "prev, pager, next",
        onCurrentChange: handleChangeCurrentPage
      }, null, 8, ["current-page", "total"]),
      _createElementVNode("p", null, " Showing " + _toDisplayString(_unref(paginationInfo).showingFrom) + " to " + _toDisplayString(_unref(paginationInfo).showingTo) + " of " + _toDisplayString(_unref(paginationInfo).total) + " results ", 1)
    ])
  ]))
}
}

})